import * as React from "react";
import { useSelector, useDispatch } from "react-redux"
import { RootReducer } from "../app/reducer"
import { Link } from "react-router-dom"

const Disclaimer : React.FC = () => {


    // this is used for the whole app
    const disclaimerAccepted = useSelector((state:RootReducer) => {
//        console.log("disclaimer index.tsx DISCLAIMER ACCEPTED GET: " + JSON.stringify(state));
        return state.appReducer.blnAppDisclaimerAgreed
    });

    // this is only used in the disclaimer
    const disclaimerRejected = useSelector((state:RootReducer) => {
//        console.log("disclaimer index.tsx DISCLAIMER REJECTED GET: " + JSON.stringify(state));
        //console.log("disclaimer index.tsx get disclaimer rejected state is  " + JSON.stringify(state))
        return state.appReducer.blnAppDisclaimerRejected    
    });

    const dispatchDisclaimer = useDispatch();


return (
<div>
    { !disclaimerAccepted && !disclaimerRejected &&
        <>			
            <p className="justified">LuxCSD makes every effort to ensure that the information provided herein is correct
                but does not guarantee its accuracy or completeness as it is prepared for general information purposes only. 
                This database of securities is a non-exhaustive one that neither covers all securities eligible in LuxCSD's system
                nor provides all details related to securities listed in. LuxCSD accepts no liability for any loss or damage
                of any type resulting from errors herein and the information contained herein is not intended to provide professional
                advice and should not be relied upon in that regard. Readers should seek appropriate professional advice where 
                necessary before taking any action based on the information contained in this document. LuxCSD makes no guarantees, 
                representations or warranties and accepts no responsibility or liability as to the accuracy of completeness of the information,
                and under no circumstances will it be liable of any loss or damage cause by reliance on any opinion, advice or statement
                made in this document.
            </p>
            <p className="justified">No part of this document may be reproduced or transmitted in any form or by any means, electronic or mechanical,
                including photocopying and recording, for any purpose without the express written consent of LuxCSD.
            </p>

            <div>
                    <div>
                        <span className="disclaimer-option">
                        <button onClick={ () => dispatchDisclaimer({type:"App/DISCLAIMERACCEPT"}) }>I Agree</button>
                        </span>
                        <span className="disclaimer-option">
                            <button onClick={ () => dispatchDisclaimer({type:"App/DISCLAIMERREJECT"}) }>I disagree</button>
                        </span>
                    </div>
                    <div className="disclaimer-note">
                        <span className="small">Please make sure that the cookies in your browser are enabled, otherwise a connection is not possible.</span>
                    </div>
                </div>


        </>
    }
    { disclaimerRejected && 
        <>
           <p>We are sorry, but access to the information is not allowed unless you accept the conditions described on the previous page.</p>
           <p>Press <Link to="/queries" className="navigation">here</Link> to go back to the Legal Conditions or go back to the Clearstream web site.</p>
        </>
    }
    { disclaimerAccepted &&
        null
    }

</div>    
	
    )
}

export default Disclaimer